import React from "react";
import { Link } from 'react-router-dom';
import Select from 'react-select';

export default (props) => {

    const {
        options,
        selectedCompany,
        handleCompany,
        handleOnChange,
        onSubmit,
        balance_limit,
        email,
        is_admin,
        isAdmin,
        isFetching
    } = props;

	return(
        <div className="white-block-content" style={{padding: '15px 30px 0 30px'}}>
            <div style={{padding: '30px 30px 0 30px'}}>
                <div>                        
                    <div style={{fontSize: '1rem', textTransform: 'uppercase', color: '#979797', marginBottom: '10px'}}>Выберите компанию</div>
                    <Select
                        name="company-list"
                        noResultsText="Список пуст"
                        value={selectedCompany && selectedCompany.id}
                        onChange={(company) => handleCompany(company)}
                        clearable={false}
                        options={options}
                        menuContainerStyle={{zIndex: 9}}
                    />
                </div>
            </div>

            <div style={{padding: '30px'}}>
                <form
                    onSubmit={isAdmin.length > 0 ? onSubmit : (e) => {e.preventDefault(); return false}}>
                    <input
                        type="email"
                        placeholder="Эл. почта"
                        required
                        className="width100"
                        value={email}
                        onChange={(e) => handleOnChange(e.target.value, 'email')}
                        />

                    <input
                        style={{marginTop: '15px'}}
                        type="number"
                        required
                        placeholder="Денежный лимит"
                        min="0"
                        className="width100"
                        value={balance_limit}
                        onChange={(e) => handleOnChange(e.target.value, 'balance_limit')}
                        />
                    
                    <div
                        style={{marginTop: '25px'}}
                        className="checkboxes checkboxes_align-left"
                        >
                        <label className="c-form__label" htmlFor="is_admin">
                            <label className="custom-radio">
                                <input
                                    checked={is_admin}
                                    className="value"
                                    type="checkbox"
                                    id="is_admin"
                                    value={is_admin}
                                    onChange={(e) => handleOnChange(is_admin ? false : true, 'is_admin')}
                                    />
                                <div></div>
                            </label>
                            <span className="text">Сделать админом</span>
                        </label>
                    </div>
                    <div className="actions">
                        <div className="big-button empty-button">
                            <Link to="/account/entity/staff">
                                <button>Отмена</button>
                            </Link>
                        </div>
                        {
                            <div className="big-button button-action">
                                <button
                                    title={isAdmin.length > 0 ? '' : 'Добавить сотрудника могут только администраторы компании'}
                                    disabled={isAdmin.length > 0 ? false : true}
                                    className={isAdmin.length > 0 && !isFetching ? '' : 'disabled'}
                                    >Сохранить</button>
                            </div>
                        }
                    </div>
                </form>
                
                
            </div>
        </div>
	)
}


// WEBPACK FOOTER //
// ./src/components/AccountLaw/StaffCreateForm.js